<template>
  <div class="alert" :class="alertClass" role="alert">
    <i :class="icon"></i>
    <p v-if="message">{{ message }}</p>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: null
    },
    message: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: 'small'
    }
  },
  computed: {
    alertClass () {
      let alertClass = ''

      if (this.type) {
        alertClass += ` alert-${this.type}`
      }

      if (this.size) {
        alertClass += ` alert-${this.size}`
      }

      return alertClass
    },
    icon () {
      if (this.size === 'small') {
        switch (this.type) {
          case 'warning':
            return 'fa fa-info-circle'
          case 'success':
            return 'fa fa-check-circle'
          case 'danger':
            return 'fa fa-exclamation-circle'
          case 'info':
            return 'fa fa-question-circle'
          default:
            return 'fa fa-check-circle'
        }
      } else {
        switch (this.type) {
          case 'warning':
            return 'fas fa-exclamation-triangle'
          case 'success':
            return 'fa fa-check-circle'
          case 'danger':
            return 'fa fa-exclamation-circle'
          case 'info':
            return 'fa fa-question-circle'
          default:
            return 'fa fa-check-circle'
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.alert {
  display: flex;
  align-items: start;
  font-size: 14px;

  i {
    margin-top: 1px;
    margin-right: 8px;
    font-size: 16px;
  }

  p {
    line-height: 18px;
  }
}
</style>
